import { Component, OnInit } from "@angular/core";

export interface ShopAndShipAdvantageItemInterface{
    image: string; 
    title: string;
    content: string;
}
@Component({
    selector: "lp-countries-advantages",
    templateUrl: "advantages.component.html",
    styleUrls: ["advantages.component.css"]
})

export class ShopAndShipAdvantagesComponent implements OnInit{

    advantages: ShopAndShipAdvantageItemInterface[] = [
        {
            title: `Competitive Pricing`, 
            content: `We offer the best competitive prices to save you on shipping rates.`, 
            image: `/assets/img/lp-countries/advantages/competitive_pricing.png`
        },
        {
            title: `International Delivery`, 
            content: `We offer one of the best shipping solutions for international shipping`, 
            image: `/assets/img/lp-countries/advantages/internatioanal_delivery.png`
        },
        {
            title: `Secure Payment`, 
            content: `Pay with peace of mind with our Safe Pay systems.`, 
            image: `/assets/img/lp-countries/advantages/secure_payment_methods.png`
        }
        ,{
            title: `Shop Safely`, 
            content: `Shop with us knowing that we are protecting your account around the clock.`, 
            image: `/assets/img/lp-countries/advantages/shop_safely.png`
        }
    ]; 
    constructor(){}
    ngOnInit(){}
}